module.exports = __webpack_public_path__ + "img/companyImg2.2a1da2de.jpg";